import { Fragment, useEffect } from "react";
import TextArea from "../controls/TextArea";

const Step7 = ({
  setText,
  text,
  validateIsErr,
  deliveryInfo,
  deliveryLoading,
  deliveryError,
  onRequestDeliveryAddress,
}) => {
  const sendMaterialValue = text.sendMaterial || "";

  useEffect(() => {
    if (sendMaterialValue === "YES") {
      onRequestDeliveryAddress();
    }
  }, [sendMaterialValue, onRequestDeliveryAddress]);

  const handleSendMaterialChange = (event) => {
    const value = event.target.value;

    if (value === "YES") {
      setText({ ...text, sendMaterial: value });
    } else {
      setText({
        ...text,
        sendMaterial: value,
        infoMtrlReturnMtrl: "",
      });
    }
  };

  const formatAddressLines = (value) => {
    if (!value) {
      return [];
    }

    const lines = value
      .split(",")
      .map((part) => part.trim())
      .filter((part) => part.length >= 3);

    return lines;
  };

  const addressRows = [
    {
      label: "Leveransadress",
      value: formatAddressLines(deliveryInfo?.LeveransAdress),
    },
    {
      label: "Leveransmottagare",
      value: formatAddressLines(deliveryInfo?.Alternativkontaktperson),
    },
    // {
    //   label: "Alternativ leveransmottagare",
    //   value: formatAddressLines(deliveryInfo?.Alternativkontaktperson),
    // },
  ];

  const deliveryTermsRows = [
    {
      label: "Bemanning dagtid",
      value: deliveryInfo?.Bemanning_dagtid,
    },
    {
      label: "Tar emot EU pall",
      value: deliveryInfo?.Tar_emot_pallar,
    },
    {
      label: "Förvaring inomhus",
      value: deliveryInfo?.["Förvaring_inomhus"],
    },
  ];

  return (
    <div className="step7-wrapper">
      <h3 className="stepH3">Material &amp; reservdelar</h3>
      <p className="step7-question">
        Behöver du skicka material eller reservdelar till oss?
      </p>
      <div
        className="step7-radio-group"
        role="radiogroup"
        aria-label="Skicka material eller reservdelar"
      >
        <label className="step7-radio">
          <input
            type="radio"
            name="sendMaterial"
            value="YES"
            checked={sendMaterialValue === "YES"}
            onChange={handleSendMaterialChange}
          />
          Ja
        </label>
        <label className="step7-radio">
          <input
            type="radio"
            name="sendMaterial"
            value="NO"
            checked={sendMaterialValue === "NO"}
            onChange={handleSendMaterialChange}
          />
          Nej
        </label>
      </div>
      {validateIsErr.sendMaterial === true && (
        <p className="step7-error">Välj ja eller nej innan du går vidare.</p>
      )}
      {sendMaterialValue === "YES" && (
        <div className="step7-content">
          <div className="step7-delivery">
            <h4 className="step7-delivery-title">Leveransinformation</h4>
            <p className="step7-delivery-subtitle">
              Nedan information finner du även på din beställningsbekräftelse.
            </p>
            {deliveryLoading ? (
              <p className="step7-loading">Hämtar leveransinformation...</p>
            ) : deliveryError ? (
              <p className="step7-error">{deliveryError}</p>
            ) : deliveryInfo ? (
              <div className="step7-delivery-layout">
                <dl className="step7-delivery-list">
                  {addressRows
                    .filter(({ value }) => value.length > 0)
                    .map(({ label, value }) => (
                      <Fragment key={label}>
                        <dt className="step7-delivery-term">{label}</dt>
                        <dd className="step7-delivery-value">
                          <div className="step7-delivery-value-lines">
                            {value.map((line, index) => (
                              <span key={`${label}-${index}`}>{line}</span>
                            ))}
                          </div>
                        </dd>
                      </Fragment>
                    ))}
                </dl>
                <dl className="step7-delivery-list step7-delivery-booleans">
                  {deliveryTermsRows.map(({ label, value }) => (
                    <Fragment key={label}>
                      <dt className="step7-delivery-term">{label}</dt>
                      <dd className="step7-delivery-value">{value}</dd>
                    </Fragment>
                  ))}
                </dl>
              </div>
            ) : (
              <p className="step7-loading">
                Ingen leveransinformation hittades.
              </p>
            )}
          </div>
          <div className="step7-textarea">
            <TextArea
              headerText="Ange material, utrustning eller reservdelar."
              jsonText="infoMtrlReturnMtrl"
              setText={setText}
              text={text}
              rows="4"
              clsname={
                validateIsErr.infoMtrlReturnMtrl ? "step7-textarea-error" : ""
              }
            />
            <p className="step7-helper">
              Ange vad som ska skickas samt eventuella instruktioner.
            </p>
            {validateIsErr.infoMtrlReturnMtrl === true && (
              <p className="step7-error">
                Fyll i information om vad som ska skickas.
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Step7;
